import http from '../axios'

// 注册
export function register(params) {
  return http.post('/sign-up/register', params)
}

// 邮件地址是否存在
export function checkEmailIsExist(params) {
  return http.post('/sign-up/check-email-is-exist', params, {
    direct: true
  })
}

// 手机号码是否存在
export function checkPhoneIsExist(params) {
  return http.post('/sign-up/check-phone-is-exist', params, {
    direct: true
  })
}

// 发送验证码
export function sendPasscode(params) {
  return http.post('/sms/send', params)
}

// 获取图片验证码
export function captcha() {
  return http.get('/sign-up/captcha?refresh=1', {
    direct: true
  })
}

// 查询用户所在的国家区号
export function searchIpArea() {
  return http.post('/sign-up/search-ip-area', '', {
    direct: true
  })
}
